<!-- Bikes -->
<div class="d-flex flex-column flex-sm-row">
  @if (bikesCount) {
    <span class="me-2">
      @if (
        companyGroupCode === 'WG' || companyGroupCode === 'GHO') {
        {{ "POSITIONS" | translate }}: {{ bikesCount }}<br />
        <small>{{ "BIKES_AMOUNT" | translate }}: {{ totalBikes }}</small
          ><br />
        } @else {
          {{ "BICYCLES" | translate }}: {{ bikesCount }}<br />
          <small>{{ "QUANTITY" | translate }}: {{ totalBikes }}</small
            ><br />
          }
        </span>
      }

      @if (bikesCount && partsCount) {
        <br />
      }

      <!-- Parts -->
      @if (partsCount) {
        <span>
          @if (
            companyGroupCode === 'WG' || companyGroupCode === 'GHO') {
            {{ "POSITIONS" | translate }}: {{ partsCount }}<br />
            <small>{{ "PARTS_AMOUNT" | translate }}: {{ totalParts }}</small
              ><br />
            } @else {
              {{ "PARTS" | translate }}: {{ partsCount }} <br />
              <small>{{ "QUANTITY" | translate }}: {{ totalParts }}</small
                ><br />
              }
            </span>
          }
        </div>
